<template>
  <v-row class="login">
    <div class="container">
<!--      <v-snackbar v-model="loginSuccess" color="success" top>-->
<!--        <span>-->
<!--          Autenticidade verificada. Sua nota será baixada em seguida para-->
<!--          visualização.-->
<!--        </span>-->
<!--        <v-btn color="info" @click="loginSuccess = false">Ok</v-btn>-->
<!--      </v-snackbar>-->

      <v-snackbar color="error" v-model="loginFail" top>
        <span>
          Consulta de empresa(s) não retornou dados com esse(s) filtro(s).
        </span>
        <v-btn color="info" @click="loginFail = false">Fechar</v-btn>
      </v-snackbar>

      <h1 class="display-1 my-3">{{ messageEmpresaAutorizacaEmissaoNota }}</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
        <v-flex xs12 sm6 xl4>
          <v-card hover class="ma-4">
            <v-card-title>Dados da empresa</v-card-title>
            <v-card-text>
              <v-form ref="form" class="my-3">
                <v-text-field
                  v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                  clearable
                  v-model="cpfCnpj"
                  @input="cpfCnpj = cpfCnpj.toUpperCase()"
                  :rules="regrasObrigacao"
                  label="CNPJ do Prestador de Serviços"
                  required
                  prepend-icon="account_circle"
                ></v-text-field>

                <v-text-field
                  clearable
                  v-model="nomeRazaoSocial"
                  label="Nome Empresarial"
                  required
                  prepend-icon="description"
                ></v-text-field>

                <v-text-field
                  clearable
                  v-model="endereco"
                  label="Endereço"
                  required
                  prepend-icon="location_on"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" dark type="submit" @click="pesquisaEmpresas">
                <v-icon small left>check_circle</v-icon>
                <span>Verificar</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>

      <v-row>
        <v-flex v-for="empresa in listaEmpresas" v-bind:key="empresa.cpfCnpj">
          <v-card hover class="ma-4">
              <v-card-title>{{ empresa.nomeRazaoSocial }}</v-card-title>
              <v-card-text class="remove-spaco-top-bottom">CNPJ: {{ formataCpfCnpj(empresa.cpfCnpj) }}</v-card-text>
              <v-card-text class="remove-spaco-top-bottom">Razão Social: {{ empresa.nomeRazaoSocial }}</v-card-text>
              <v-card-text class="remove-spaco-top-bottom">Endereço: {{ empresa.endereco }}</v-card-text>
              <v-card-text class="remove-spaco-top-bottom">Município: {{ empresa.municipio }}</v-card-text>
              <v-card-text class="remove-spaco-top-bottom">Estado: {{ empresa.estado }}</v-card-text>
          </v-card>


<!--        <div class="card" v-for="empresa in listaEmpresas" v-bind="empresa.cpfCnpj">-->
<!--          <h5 class="card-header" style="text-align: center">{{ empresa.nomeRazaoSocial }}</h5>-->
<!--          <div class="card-body">-->
<!--            <h5 class="card-title" style="text-align: left">CNPJ: {{ formataCpfCnpj(empresa.cpfCnpj) }}</h5>-->
<!--            <h5 class="card-title" style="text-align: left">Razão Social: {{ empresa.nomeRazaoSocial }}</h5>-->
<!--            <h5 class="card-text" style="text-align: left">Endereço: {{ empresa.endereco }}</h5>-->
<!--            <h5 class="card-text" style="text-align: left">Município: {{ empresa.municipio }}</h5>-->
<!--            <h5 class="card-text" style="text-align: left">Estado: {{ empresa.estado }}</h5>-->
<!--          </div>-->
<!--        </div>-->
        </v-flex>
      </v-row>
    </div>
  </v-row>
</template>

<script>
// import { httpNF } from "../axios.config";
import {mask} from "vue-the-mask";
import EventService from "../services/EventService";
// import swal from "sweetalert";

export default {
  directives: { mask },
  data() {
    return {
      cpfCnpj: null,
      nomeRazaoSocial: null,
      endereco: null,
      regrasObrigacao: [(v) => !!v || "Campo obrigatório!"],
      loginSuccess: false,
      loginFail: false,
      listaEmpresas: null,
      messageEmpresaAutorizacaEmissaoNota: ""
    };
  },
  methods: {
    formataCpfCnpj(cpfCnpj) {
      if (cpfCnpj.length <= 11) {
        return this.mascaraCpf(this.retiraFormatacao(cpfCnpj))
      } else {
        return this.mascaraCnpj(this.retiraFormatacao(cpfCnpj))
      }
    },
    retiraFormatacao(cpfCnpj) {
      return cpfCnpj.replace(/(\.|\/|-)/g, "")
    },
    mascaraCpf(cpf) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4")
    },
    mascaraCnpj(cnpj)  {
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
    },
    pesquisaEmpresas() {
      if (this.cpfCnpj) {
        this.cpfCnpj = this.removeMask(this.cpfCnpj);
      }

      if (this.$refs.form.validate()) {
        this.$httpNF("empresa", {
          method: "GET",
          responseType: "json",
          headers: {
            multiTenantId: 8,
            cpfCnpj: this.cpfCnpj,
            nomeRazaoSocial: this.nomeRazaoSocial,
            endereco: this.endereco,
          },
        }).then((res) => {
          this.listaEmpresas = res.data;

          if (this.listaEmpresas.length) {
            this.loginSuccess = true;
            // Swal.fire({
            //     title: 'Resultado pesquisa',
            //     text: "Consulta de empresa(s) efetuado com sucesso.",
            //     type: 'success',
            //     showCancelButton: false,
            //     confirmButtonText: 'OK'
            // })
          } else {
            this.loginFail = true;
            // swal({
            //   title: "Resultado pesquisa",
            //   origin: "Consulta de empresa(s) não retornou dados com esse(s) filtro(s).",
            //   type: "error",
            //   button: "OK",
            // });
          }
        });
      }
    },
    removeMask(mask) {
      return mask.replace(/[^a-zA-Z0-9]/g, "");
    },
  },
  created() {
    EventService.getBundle("message.portalEmpresaAutorizadaEmissaoNota").then(response => {
      this.messageEmpresaAutorizacaEmissaoNota = response.data;
    });

  },
};
</script>

<style>
  .remove-spaco-top-bottom {
    padding-top: 1px;
    padding-bottom: 1px;
  }
</style>